import "./ThemeErrorSummary.scss";
import { FormikErrors } from "formik";

interface ThemeErrorSummaryProps {
  errors: FormikErrors<any>;
}

const ThemeErrorSummary = ({ errors }: ThemeErrorSummaryProps) => {
  const errorEntries = Object.entries(errors).filter(
    (entry): entry is [string, string] =>
      typeof entry[1] === "string" && entry[1].trim() !== "",
  );

  if (!errorEntries.length) return null;

  return (
    <>
      <div className="theme-warning-container">
        <div className="warning-summary">
          <div className="warning-header">
            <div className="warning-icon">
              <img src="/images/warning-icon.svg" alt="warning" />
            </div>
            <span className="warning-title">Brand Color Warnings</span>
          </div>
          <div className="warning-content">
            <p>Improving these colors will ensure better output.</p>
            <p className="note">
              Note: Submission is still available despite these warnings.
            </p>
          </div>
        </div>

        <ul className="warning-list">
          {errorEntries.map(([field, message]) => (
            <li key={field}>{message}</li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default ThemeErrorSummary;
